import {
  GetSlideStylesDocument,
  type SlideStyleType as GqlSlideStyleType,
} from "@/generated/graphql";
import type { SlideStyleType } from "@ai-teach/types";
import { useQuery } from "@apollo/client/react";

export const SLIDE_STYLES_LIMIT = 6;

export function useSlideStyle({
  type,
  searchText,
  skip = false,
}: { type: SlideStyleType; searchText?: string; skip?: boolean }) {
  const gqlType = type as GqlSlideStyleType;

  const { data, loading, error, fetchMore } = useQuery(GetSlideStylesDocument, {
    variables: {
      type: gqlType,
      limit: SLIDE_STYLES_LIMIT,
      offset: 0,
      searchText: searchText ?? undefined,
    },
    fetchPolicy: "cache-first",
    skip,
  });

  const items = data?.getSlideStyles?.items;
  const hasMore = data?.getSlideStyles?.hasMore;

  const loadMore = () => {
    fetchMore({
      variables: {
        type: gqlType,
        limit: SLIDE_STYLES_LIMIT,
        offset: items?.length ?? 0,
        searchText: searchText ?? undefined,
      },

      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;

        return {
          getSlideStyles: {
            ...fetchMoreResult.getSlideStyles,
            items: [...prev.getSlideStyles.items, ...fetchMoreResult.getSlideStyles.items],
          },
        };
      },
    });
  };

  return { items, hasMore, isLoading: loading, error, loadMore };
}
